// https://github.com/giantcz/gia
// Add import to js/components
import Component from 'gia/Component'
import { throttle } from 'lodash'

export default class HamburgerComponent extends Component {

  constructor(element) {
    super(element);

    this.isOpen = false
    this.body = document.body

    this.ref = {
      button: null
    }
  }


  mount() {
    this.ref.button.addEventListener('click', this.toggleMenu.bind(this));
    window.addEventListener('scroll', throttle(this.scrollReset.bind(this),200));
  }

  toggleMenu(e) {
    e.preventDefault();
    // this.body.classList.toggle('menu-open');
    // this.isOpen = this.body.classList.contains('menu-open');
    // // if now open
    // if (this.isOpen) {
    //   document.body.style.top = `-${window.scrollY}px`;
    //   document.body.style.position = 'fixed';
    // } else {
    //   const scrollY = document.body.style.top;
    //   document.body.style.position = '';
    //   document.body.style.top = '';
    //   window.scrollTo(0, parseInt(scrollY || '0') * -1);
    // }

  }

  scrollReset(e) {
    document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
  }
}
